// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const spendeFuerDieStiftungFuerKrebskrankeKinderCoburg3DE: PageEntry = {
  id: "post.spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3",
  locale: "de",
  slug: "spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3",
  seo: {
    title: "Neue Auszubildende 2018 | Dietz GmbH",
    description: "Neue Auszubildende 2018",
  },
  type: "post",
  h1: "Neue Auszubildende 2018",
  blocks: [
    { kind: "heading", level: 2, text: "Neue Auszubildende 2018" },
    { kind: "paragraph", text: "„Als Familienunternehmen legen wir viel Wert auf die Ausbildung eigener Nachwuchskräfte“, mit diesen Worten begrüßte der Ausbildungsleiter Michael Wagner herzlich die sechs neuen Auszubildenden der Dietz GmbH." },
    { kind: "paragraph", text: "In diesem Jahr haben wir die Ausbildungsberufe wie folgt besetzt: eine technische Produktdesignerin, eine Fachkraft für Lagerlogistik und vier Industriemechaniker/-innen." },
    { kind: "paragraph", text: "„Wir wünschen euch eine erfolgreiche Zukunft und einen guten Start in das Berufsleben!“ – Ausbildungsleiter Michael Wagner." }
  ],
};
